import axios from 'axios'
import Vue from 'vue';
import { Loading, Message, MessageBox } from 'element-ui'
import route from '../router/index'
Vue.prototype.$message = Message
var _this = this
 // import qs from 'qs'
// 创建一个axios实例
const service = axios.create()

// 添加请求拦截器
var loadinginstace;
 service.interceptors.request.use(config => {

  // 在发送请求之前做某事，比如说 设置token
  // config.headers['token'] = 'token';
  config.headers["Content-Type"] ='application/json';
  if(config.platFlag=='notoken'){

  }else{
    if(localStorage.getItem('token')!='undefined'&&localStorage.getItem('token')!=null){
      config.headers["Authorization"] ='Bearer '+localStorage.getItem('token');
    }
  }

    loadinginstace = Loading.service({ fullscreen: true })
     return config

}, error => {
   loadinginstace.close();
  // 请求错误时做些事
  return Promise.reject(error);
});

// 添加响应拦截器
 service.interceptors.response.use(response => {
  loadinginstace.close();
  const res = response.data;
  // 如果返回的状态不是200 就主动报错
  //
  console.log(res.code)
  if(res.state != 200 &&res.code!=0&&res.code!=1&&res.code!=400){
      return Promise.reject(res)
    }
  return response;
}, error => {
   loadinginstace.close();
 console.log(error.response.data)
 const res = error.response.data
 // if(res.code==1&&res.msg=='你的登录信息已失效！请重新登录！'){
 //   route.replace({ path: "/login" });
 // }
 // alert(error.response.data.msg)

    return Promise.reject(error.response.data); // 返回接口返回的错误信息
})

export default service



// WEBPACK FOOTER //
// ./src/api/axiosFun.js